__turbopack_context__.v({
  "btnWrapper": "dropdown-module__6QC_FW__btnWrapper",
  "button": "dropdown-module__6QC_FW__button",
  "inlinePanel": "dropdown-module__6QC_FW__inlinePanel",
  "panel": "dropdown-module__6QC_FW__panel",
  "wrapper": "dropdown-module__6QC_FW__wrapper",
});
